module.exports = __webpack_public_path__ + "public/Icons/languageIcon.svg?5f664587";